type CoordinateLike = {
  latitude?: number | null
  longitude?: number | null
}

type ViewportLike = CoordinateLike & {
  zoom?: number | null
}

type HomeLocationLike = {
  x?: number | null
  y?: number | null
  z?: number | null
}

const isFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value)

export const isValidLatitude = (value: unknown): value is number =>
  isFiniteNumber(value) && value >= -90 && value <= 90

export const isValidLongitude = (value: unknown): value is number =>
  isFiniteNumber(value) && value >= -180 && value <= 180

export const isValidZoom = (value: unknown): value is number =>
  isFiniteNumber(value) && value >= 0 && value <= 22

export const hasValidCoordinates = <T extends CoordinateLike>(
  coordinates: T | null | undefined
): coordinates is T & { latitude: number; longitude: number } =>
  isValidLatitude(coordinates?.latitude) &&
  isValidLongitude(coordinates?.longitude)

export const hasValidViewport = <T extends ViewportLike>(
  viewport: T | null | undefined
): viewport is T & { latitude: number; longitude: number; zoom: number } =>
  hasValidCoordinates(viewport) && isValidZoom(viewport?.zoom)

export const hasValidHomeLocation = <T extends HomeLocationLike>(
  location: T | null | undefined
): location is T & { x: number; y: number; z: number } =>
  isValidLatitude(location?.x) &&
  isValidLongitude(location?.y) &&
  isValidZoom(location?.z)
